import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
} from "App/constants";
import {
  InputCheckboxMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";

import { Grid } from "@material-ui/core";
import { useState } from "react";

import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const getAllLayanan = async () => {
  try {
    const api = await instance1.get(LIST_URL_MASTER.layanan.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteLayananById = async (
  id,
  setNewData,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      LIST_URL_MASTER.layanan.delete,
      {},
      {
        headers: {
          idlayanan: id,
        },
      }
    );
    setShowModalDeleteConfirm(false);
    setFormData({
      id: "",
      name: "",
      code: "",
    });
    setNewData();
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "initial",
    disablePadding: false,
    label: "INITIAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "spesific_code",
    disablePadding: false,
    label: "KODE SPESIFIK",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, data, setNewData }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const [formData, setFormData] = useState({
    name: data.name,
    spesific_code: data.spesific_code,
    initial: data.initial,
    status: data.status,
    remark: data.remark,
    id: data.id,
  });

  const addLayanan = async () => {
    return instance1.post(LIST_URL_MASTER.layanan.add, {
      ...formData,
    });
  };

  const updateLayanan = () => {
    return instance1.post(
      LIST_URL_MASTER.layanan.update,
      {
        ...formData,
      },
      {
        headers: {
          idlayanan: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.initial === "" || formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama dan initial tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addLayanan();
        } else if (formData.id !== "") {
          await updateLayanan();
        }
        setNewData();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`${titleModal(formData.id)} Layanan`} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='initial'
              label='Initial'
              id='initial'
              value={formData.initial}
              onChange={handleChange("initial")}
              placeholder='Initial'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='spesific_code'
              label='Kode Spesifik'
              id='spesific_code'
              value={formData.spesific_code}
              onChange={handleChange("spesific_code")}
              placeholder='Kode Spesifik'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>

          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.status}
              name='status'
              id='status'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, status: !formData.status })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
